import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon';
import {
  getDetailClickEventTrackingData,
  mapFooterIconsToContactsBarTypes,
} from 'Components/utils/booking-footer/bookingFooter.utils';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';

type BookingFooterItemProps = {
  href: string;
  text: Array<string>;
  type: string;
  itemTrackingData?: { id: number };
};

export const BookingFooterItem = ({ href, text, type }: BookingFooterItemProps) => {
  const { trackClickEvent } = useTrackEvent();
  return (
    <a
      className="flex flex-col items-center text-center"
      data-testid={`BookingFooterItem-${type}`}
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={() => {
        const detailClick = getDetailClickEventTrackingData(type, href);
        trackClickEvent(TRACK_EVENT_NAMES.CLICK_FOOTER, {
          detail_click: detailClick,
        });
      }}
    >
      <Icon
        name={mapFooterIconsToContactsBarTypes?.[type] || ICONS.WARNING}
        width="1.4375rem"
        className="m-15"
        dataTestid="BookingFooterItem-icon"
      />
      {text.map((txt, index) => (
        <p
          key={txt[index]}
          className={classnames('text-14', { 'font-bold': index === 0 }, { 'mb-10': index !== 0 })}
        >
          {txt}
        </p>
      ))}
    </a>
  );
};
